import discardCalendarSurfaceAddinsOption from './actions/discardCalendarSurfaceAddinsOption';
import saveCalendarSurfaceAddinsOption from './actions/saveCalendarSurfaceAddinsOption';
import CalendarSurfaceAddins from './components/CalendarSurfaceAddins';
import isCalendarSurfaceAddinsOptionDirty from './utils/isCalendarSurfaceAddinsOptionDirty';
import { isFeatureEnabled } from 'owa-feature-flags';
import { Option } from 'owa-options-core';
import * as React from 'react';

let CalendarSurfaceAddinsOption: Option = {
    key: 'calendarSurfaceAddins',
    titleStringKey: 'optionTitle_calendarSurfaceAddins',
    searchTermsStringKey: 'optionTitle_calendarSurfaceAddins',
    fullOptionFormSettings: {
        render: () => <CalendarSurfaceAddins />,
        isDirty: isCalendarSurfaceAddinsOptionDirty,
        onSave: saveCalendarSurfaceAddinsOption,
        onDiscard: discardCalendarSurfaceAddinsOption,
    },
    isHidden: () => !isFeatureEnabled('cal-addins'),
};

export default CalendarSurfaceAddinsOption;
